/* eslint-disable no-shadow */
// import Immutable from 'seamless-immutable';
import createReducer from '../../helpers/createReducer';
import {
  interactions as state
} from '../store';

export default createReducer(state, {
  SAVE_INTERACTIONS: (state, { data: interactions }) => ({ ...state, ...interactions }),
  SET_WHOLE_INTERACTIONS: (state, { data: interactions }) => ({ ...state, ...interactions })
});
